import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import TenantUserRemoveMenuItem from "@/v2-backoffice-client/tenant/user/remove/TenantUserRemoveMenuItem"
import UserCustomerUpdateSelectorDialogMenuItem from "@/v2-backoffice-client/user/customer/update/UserCustomerUpdateSelectorDialogMenuItem"
import type { UserCustomerMismatchFragment } from "@/v2-backoffice-client/user/customerMismatch/__types__/user.customerMismatch.fragment"
import { formatUserName } from "@/v2-backoffice-client/user/user.utils"

export type UserCustomerMismatchRowToolbarProps = {
  mismatch: UserCustomerMismatchFragment
  /** The row is gone once the user is out of the team; the board refetches. */
  onCompleted?(): void
}

/**
 * The row's other ways out, for when neither of the Put Right cell's
 * choices is the right one: pick any customer for the user, or take the
 * user out of the team.
 */
function UserCustomerMismatchRowToolbar(
  props: UserCustomerMismatchRowToolbarProps,
) {
  const { mismatch, onCompleted } = props
  const { User: user } = mismatch

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        {user && (
          <UserCustomerUpdateSelectorDialogMenuItem user={user}>
            Update Customer...
          </UserCustomerUpdateSelectorDialogMenuItem>
        )}

        <ActionMenu.Separator />

        <TenantUserRemoveMenuItem
          tenantId={mismatch.TenantId}
          userId={mismatch.UserId}
          userName={formatUserName(user?.FirstName, user?.LastName)}
          onCompleted={onCompleted}
        />
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default UserCustomerMismatchRowToolbar
